import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-patient-appointments-layout",
  templateUrl: "./patient-appointments-layout.component.html",
  styleUrls: ["./patient-appointments-layout.component.scss"]
})
export class PatientAppointmentsLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
